// Can be used to run functions depending on the current page

export default function () {
    console.log('router');
}
